import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { BrandMark } from "@/components/BrandMark";

const links = [
  { to: "/services", label: "Services", id: "navbar-link-services" },
  { to: "/livres", label: "Livres", id: "navbar-link-books" },
  { to: "/le-cercle", label: "Le Cercle", id: "navbar-link-cercle" },
  { to: "/youtube", label: "YouTube", id: "navbar-link-youtube" },
  { to: "/contact", label: "Contact", id: "navbar-link-contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "glass py-3" : "py-5 bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 flex items-center justify-between">
        <Link to="/" data-testid="navbar-logo" className="flex items-center gap-3">
          <BrandMark size={40} className="shrink-0" />
          <span className="flex flex-col leading-none">
            <span className="font-serif text-lg sm:text-xl tracking-wide gold-text">YoungspiritClub</span>
            <span className="text-[10px] tracking-[0.24em] uppercase text-amber-400/60 font-mono-accent mt-0.5">
              Science × Spiritualité × Ingénierie Intérieure
            </span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={l.id}
              className={`text-sm font-sans tracking-wide transition-colors hover:text-amber-300 ${
                pathname === l.to ? "text-amber-300" : "text-slate-300"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/admin"
            data-testid="navbar-link-admin"
            className="text-sm px-4 py-2 rounded-full border border-amber-500/30 text-amber-200 hover:bg-amber-500/10 transition-colors"
          >
            Espace Admin
          </Link>
        </div>

        <button
          className="md:hidden text-amber-200"
          onClick={() => setOpen((o) => !o)}
          data-testid="navbar-mobile-toggle"
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden glass mt-3 mx-4 rounded-2xl p-5 flex flex-col gap-4">
          {links.map((l) => (
            <Link key={l.to} to={l.to} data-testid={`m-${l.id}`} className="text-slate-200 hover:text-amber-300">
              {l.label}
            </Link>
          ))}
          <Link to="/admin" className="text-amber-200 border-t border-amber-500/15 pt-4">
            Espace Admin
          </Link>
        </div>
      )}
    </header>
  );
};
